<template>
  <DanhSachTinhThanh />
</template>

<script>
import DanhSachTinhThanh from "@/components/pages/quan-ly-danh-muc/tinh-thanh/DanhSachTinhThanh";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";
export default {
  name: "TrangDanhSachThongBao",
  components: {
    DanhSachTinhThanh
  },
  created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.TINH_THANH.XEM
      }`
    );
  }
};
</script>


